import React, { useState } from 'react';
import { Box, Paper, Typography, Button, Chip, Stepper, Step, StepLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useKBTheme } from '../../hooks/useKBTheme';
import { mockApprovals } from '../../data/mockData';

export const DemoApprovalFlow: React.FC = () => {
  const { mode } = useKBTheme();
  const [approval] = useState(mockApprovals[0]);
  const [currentStep, setCurrentStep] = useState(0);
  const [approved, setApproved] = useState(false);

  const steps = ['Ticket Created', 'Approval Requested', 'Under Review', 'Decision Made'];

  const handleApprove = () => {
    setCurrentStep(3);
    setApproved(true);
  };

  return (
    <Box>
      <Stepper activeStep={currentStep} sx={{ mb: 3 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Paper
        sx={{
          p: 3,
          mb: 2,
          background: mode === 'dark' ? 'rgba(71, 85, 105, 0.4)' : 'rgba(255, 255, 255, 0.8)',
          border: '1.5px solid',
          borderColor: approved ? '#10b981' : '#6366f1',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: mode === 'dark' ? '#fff' : '#0f172a' }}>
            {approval.title}
          </Typography>
          {approved && (
            <CheckCircleIcon sx={{ color: '#10b981', fontSize: 20 }} />
          )}
        </Box>
        <Typography variant="body2" sx={{ color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#64748b', mb: 2 }}>
          {approval.description}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
          <Chip label={`Priority: ${approval.priority}`} size="small" />
          <Chip label={`Requested by: ${approval.requested_by.split('@')[0]}`} size="small" />
        </Box>
        {!approved && currentStep < 3 && (
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleApprove}
              sx={{
                background: 'linear-gradient(135deg, #10b981, #059669)',
                '&:hover': { background: 'linear-gradient(135deg, #059669, #047857)' },
              }}
            >
              Approve
            </Button>
            <Button variant="outlined" color="error">
              Reject
            </Button>
          </Box>
        )}
        {approved && (
          <Box sx={{ mt: 2, p: 2, borderRadius: 2, bgcolor: 'rgba(16, 185, 129, 0.1)', border: '1px solid #10b981' }}>
            <Typography variant="body2" sx={{ color: '#10b981', fontWeight: 600 }}>
              ✅ Approved - Ticket proceeding to assigned team
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};








